module.exports = __webpack_public_path__ + "img/home.8314e79f.svg";